/** 移动端调试面板（App WebView / 微信内） */

import { isInsurancePlanShareLanding } from '@/utils/share-landing';

export { isInsurancePlanShareLanding } from '@/utils/share-landing';

let started = false;

export function enableVConsole(): void {
  if (started || typeof window === 'undefined') return;
  started = true;
  void import('vconsole')
    .then(({ default: VConsole }) => {
      // eslint-disable-next-line no-new
      new VConsole();
    })
    .catch((e) => {
      started = false;
      console.warn('[vconsole] load failed', e);
    });
}

/** 地址带 ?vconsole=1 / ?debug=1 时启用 */
export function maybeEnableVConsoleFromQuery(
  search: string = typeof location !== 'undefined' ? location.search : ''
): void {
  try {
    const q = new URLSearchParams(search);
    if (q.get('vconsole') === '1' || q.get('debug') === '1') {
      enableVConsole();
    }
  } catch {
    /* ignore */
  }
}

/** 计划书分享落地页默认开启 vConsole（share=1 或 proposal/market/review） */
export function maybeEnableVConsoleForShareLanding(
  pathname: string = typeof location !== 'undefined' ? location.pathname : '',
  search: string = typeof location !== 'undefined' ? location.search : ''
): void {
  try {
    if (isInsurancePlanShareLanding(pathname, search)) {
      enableVConsole();
    }
  } catch {
    /* ignore */
  }
}
